var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpot1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 405,
    height: 343,
    viewBox: "0 0 405 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1004 55.4034C70.9179 -29.0648 133.867 -0.059356 244.942 32.8632C356.018 65.7858 394.055 50.2794 404.187 163.752C414.319 277.226 171.658 385.766 107.354 324.71C43.0508 263.653 -34.7171 139.872 18.1004 55.4034Z",
    fill: "#FF8303",
    fillOpacity: 0.72
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpot1);
export default __webpack_public_path__ + "static/media/spot1.4f7ecc025d62a3b5ce9dc088754de0a0.svg";
export { ForwardRef as ReactComponent };